import {
  SET_CURRENT_USER,
  UNSET_CURRENT_USER,
  PASSWORD_VERIFY_SUCCESS,
  PASSWORD_RESET_RES
} from '../actions/types';

const initialState = {
  currentUser: {
    id: '',
    company_id: '',
    company: {},
    email: '',
    token: '',
    first_name: '',
    last_name: '',
    phone: '',
    number: null,
    profile_photo_url: '',
    roles: [],
    is_admin: false,
    passwordVerified: false
  },
  passwordResetRes: null,
  error: false,
}

export function auth(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_USER:
      action.user.is_admin = action.user.roles.filter(r => r.name === 'admin').length > 0;

      localStorage.removeItem('user');
      localStorage.setItem('user', JSON.stringify(action.user));
      localStorage.removeItem('last_user_photo');
      localStorage.setItem('last_user_photo', action.user.profile_photo_url);
      localStorage.setItem('token', action.user.token);
      localStorage.setItem('Number', action.user.number)

      return Object.assign({}, state, { currentUser: action.user });
    case UNSET_CURRENT_USER:
      return Object.assign({}, state, { currentUser: initialState.currentUser });
    case 'SET_ERROR':
      return Object.assign({}, state, { error: action.payload })
    case PASSWORD_VERIFY_SUCCESS:
      let newCurrentUser = Object.assign({}, state.currentUser, { passwordVerified: action.val });
      return Object.assign({}, state, { currentUser: newCurrentUser });
    case PASSWORD_RESET_RES:
      return Object.assign({}, state, { passwordResetRes: action.res });
    default:
      return state;
  }
}

export function setErrorMsg (error=null, action) {
  if(action.type==="SET_ERROR") {
    return action.payload;
  }

  return error
};


// WEBPACK FOOTER //
// ./src/reducers/auth.js